
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 8a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.204 12c-.19.284-.378.571-.58.848a20.644 20.644 0 01-2.583 2.888C17.358 17.286 14.87 19 11.999 19c-2.87 0-5.359-1.715-7.04-3.264a20.648 20.648 0 01-2.584-2.888c-.202-.277-.39-.564-.58-.848l.375-.558c.236-.348.495-.682.76-1.009a20.65 20.65 0 012.028-2.169C6.641 6.714 9.13 5 12 5c2.871 0 5.36 1.715 7.042 3.264a20.646 20.646 0 012.583 2.888c.202.277.39.564.58.848zM4.24 12a18.762 18.762 0 012.073-2.264C7.888 8.286 9.899 7 11.999 7s4.112 1.285 5.687 2.736c.93.856 1.652 1.72 2.073 2.264a18.765 18.765 0 01-2.073 2.264C16.111 15.714 14.1 17 11.999 17c-2.1 0-4.111-1.285-5.686-2.736A18.767 18.767 0 014.24 12z"}})])
          )
        }
      }
    